import { render, staticRenderFns } from "./networkTraffic_top10.vue?vue&type=template&id=803b419e"
import script from "./networkTraffic_top10.vue?vue&type=script&lang=js"
export * from "./networkTraffic_top10.vue?vue&type=script&lang=js"
import style0 from "./networkTraffic_top10.vue?vue&type=style&index=0&id=803b419e&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports